import dayjs from 'dayjs';
import { defaultValues, EMPTY_CONTRACT } from './defaultValues';
import { TCreateOrganizationForm } from './schema';
import { TOrganizationServerCamel } from '@/types/organizations';

/**
 * Maps a fetched organization into the create/edit organization form shape,
 * falling back to the form's default values for any missing fields.
 * @param organization - The organization fetched from the API.
 * @returns Form values to populate the edit organization form with.
 */
export const mapOrganizationToFormValues = (
  organization: TOrganizationServerCamel,
): TCreateOrganizationForm => ({
  name: organization.name,
  language: organization.language ?? defaultValues.language,
  country: organization.country ?? null,
  state: organization.state ?? null,
  address1: organization.address1 ?? null,
  address2: organization.address2 ?? null,
  city: organization.city ?? null,
  zip: organization.zip ?? null,
  pocSettings: {
    name: organization.pocSettings?.name ?? '',
    title: organization.pocSettings?.title ?? '',
    email: organization.pocSettings?.email ?? '',
    phone: organization.pocSettings?.phone ?? defaultValues.pocSettings.phone,
    country: organization.pocSettings?.country ?? null,
    state: organization.pocSettings?.state ?? null,
    address1: organization.pocSettings?.address1 ?? null,
    address2: organization.pocSettings?.address2 ?? null,
    zip: organization.pocSettings?.zip ?? null,
  },
  configuration: {
    tfa: organization.configuration?.tfa ?? defaultValues.configuration.tfa,
    symptomTriage:
      organization.configuration?.symptomTriage ??
      defaultValues.configuration.symptomTriage,
    triageProvider: organization.configuration?.triageProvider,
    medicalStationCalls:
      organization.configuration?.medicalStationCalls ??
      defaultValues.configuration.medicalStationCalls,
    canarySpeech:
      organization.configuration?.canarySpeech ??
      defaultValues.configuration.canarySpeech,
    medwand:
      organization.configuration?.medwand ??
      defaultValues.configuration.medwand,
  },
  provisioning: {
    type: organization.provisioning?.type ?? defaultValues.provisioning.type,
    scope: organization.provisioning?.scope ?? '',
    contracts: organization.provisioning?.contracts?.length
      ? organization.provisioning.contracts.map((contract) => ({
          id: contract.id,
          seats: contract.seats != null ? String(contract.seats) : null,
          stationLicenses:
            contract.stationLicenses != null
              ? String(contract.stationLicenses)
              : null,
          consultsPerMonth:
            contract.consultsPerMonth != null
              ? String(contract.consultsPerMonth)
              : null,
          contractStartDate: contract.contractStartDate
            ? dayjs(contract.contractStartDate).toDate()
            : null,
          contractEndDate: contract.contractEndDate
            ? dayjs(contract.contractEndDate).toDate()
            : null,
        }))
      : [EMPTY_CONTRACT],
  },
});
